import VuejsClipper from '@packages/vuejs-clipper'

import CreateResultView from './Create/View'
import CreateButton from './CreateButton'
import ResultLoader from './Loader'
import Rating from './Rating'
import ResultList from './List'

export default function install(Vue) {
  Vue.component(ResultLoader.name, ResultLoader)
  Vue.component('CreateResultView', CreateResultView)
  Vue.component('ResultCreateButton', CreateButton)
  Vue.component('ResultRating', Rating)
  Vue.component('ResultList', ResultList)
  Vue.use(VuejsClipper, {
    components: {
      clipperFixed: 'image-clipper-basic',
      clipperPreview: 'my-preview',
      clipperUpload: 'clipper-upload',
      clipperRange: 'clipper-range',
    },
  })
}
